import { render } from "./OrderNulled.vue?vue&type=template&id=1584d9c8"
import script from "./OrderNulled.vue?vue&type=script&lang=js"
export * from "./OrderNulled.vue?vue&type=script&lang=js"

import exportComponent from "/Users/david/Desktop/projects/ConexionCreativa/rg-business/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__